import React from 'react';
import { Flex, Heading, Box, Text } from 'rebass';
import { graphql } from "gatsby";
import BorderWrapper from "../borderWrapper";
import { getLinkWithComponent, useGetFieldsByName } from "../../utils";
import Button from "../button";
import Image from "../image";
import { assocPath, path } from "ramda";
import Container from "./container";
import { descriptionConfig } from "../posed";
import posed from "react-pose";
import useSlidePose from "../../hooks/useSlidePose";
import { transitionDuration } from "../loader";
import theme from "../../gatsby-plugin-theme-ui";
import { useColorMode } from "theme-ui";

const PosedHeading = posed(Heading)(assocPath(['active', 'transition', 'delay'], transitionDuration, descriptionConfig));
const PosedText = posed(Text)(assocPath(['active', 'transition', 'delay'], transitionDuration, descriptionConfig));

const ModuleZoneDeRebond = ({ module, state, index, intensive = false }) => {
	const [colorMode] = useColorMode();
	const { link, descriptionString, title } = useGetFieldsByName(['descriptionString', 'link', 'title'], module, colorMode);
	const pose = useSlidePose(state, index);
	const image = path(['relationships', 'image', 'relationships', 'file', 'localFile', 'childImageSharp', 'fluid'], module)
	return (
		<BorderWrapper
			justifyContent="flex-end"
			flexDirection={['column', null, 'row']}
			alignItems={['stretch', null, 'flex-start']}
		>
			{image ? <Image
				width={['100%', null, `calc(100% - ${theme.space[3] * 2}px)`]}
				height={['100%', null, `calc(100% - ${theme.space[3] * 2}px)`]}
				sx={{ position: [null, null, 'absolute'], left: [null, null, theme.space[3]], top: [null, null, theme.space[3]] }}
				fluid={image}
			/> : null}
			<Flex
				height="100%"
				width={['100%', null, 0.55]}
			>
				<Box
					width="100%"
					height="100%"
					sx={{
						display: ['none', null, 'block'],
						position: 'relative',
						zIndex: 0,
						flexGrow: 1,
						backdropFilter: 'blur(10px)',
						':before': {
							content: "''",
							position: 'absolute',
							left: 0, top: 0, right: 0, bottom: 0,
							bg: 'background',
							opacity: intensive ? 0.5 : 0.3,
							zIndex: -1,
						}
					}}
				>
				</Box>
				<Container justifyContent="flex-end" >
					<Flex
						width={['100%', null, 0.5]}
						flexDirection="column"
						alignItems={['center', null, 'flex-start']}
						justifyContent="center"
						sx={{
							textAlign: ['center', null, 'left']
						}}
					>
						{title  ? <PosedHeading mb={[3, null, 4]} pose={pose} fontSize={[6, null, 80]} width="100%">{title}</PosedHeading> : null}
						{descriptionString ? <PosedText mb={[2, null, 3]} pose={pose} lineHeight={1.6} fontSize={[1, null, null, 2]} width="100%">{descriptionString}</PosedText> : null}
						{link ? <Button {...getLinkWithComponent(link.uri)}>{link.title}</Button> : null}
					</Flex>
				</Container>
			</Flex>
		</BorderWrapper>
	)
};

export default ModuleZoneDeRebond;

export const query = graphql`
    fragment moduleZoneDeRebondFragment on paragraph__module_zone_de_rebond {
        internal {
            type
        }
        link: field_link {
            title
            uri
        }
        title: field_description_brut
        link_dark: field_dark_link {
            title
            uri
        }
        title_dark: field_dark_description_brut
        relationships {
            image: field_image {
                relationships {
                    file: field_media_image {
                        localFile {
                            childImageSharp {
                                fluid(maxWidth: 1920, quality: 80) {
                                    ...GatsbyImageSharpFluid_withWebp
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
